export default "__VITE_ASSET__EonXxLvI__"